var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfiledropdownChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "messenger",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.106,
    height: 19.106,
    viewBox: "0 0 19.106 19.106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path891",
    d: "M0-682.665H19.106v19.106H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g885",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g889",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g895",
    transform: "translate(0.746 0.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path897",
    d: "M-305.859,0a8.807,8.807,0,0,0-8.807,8.807,8.765,8.765,0,0,0,1.335,4.662l-1.335,4.144,4.144-1.335a8.765,8.765,0,0,0,4.662,1.335,8.807,8.807,0,0,0,8.807-8.807A8.807,8.807,0,0,0-305.859,0Z",
    transform: "translate(314.666)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "g899",
    transform: "translate(8.62 8.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path901",
    d: "M-64.8-32.4a.933.933,0,0,1-.933.933.933.933,0,0,1-.933-.933.933.933,0,0,1,.933-.933.933.933,0,0,1,.933.933",
    transform: "translate(66.667 33.333)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g903",
    transform: "translate(12.352 8.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path905",
    d: "M-64.8-32.4a.933.933,0,0,1-.933.933.933.933,0,0,1-.933-.933.933.933,0,0,1,.933-.933.933.933,0,0,1,.933.933",
    transform: "translate(66.667 33.333)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g907",
    transform: "translate(4.888 8.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path909",
    d: "M-64.8-32.4a.933.933,0,0,1-.933.933.933.933,0,0,1-.933-.933.933.933,0,0,1,.933-.933.933.933,0,0,1,.933.933",
    transform: "translate(66.667 33.333)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiledropdownChat);
export default __webpack_public_path__ + "static/media/profiledropdown-chat.e245f4f0d427d6f18912fd70a11ea3cb.svg";
export { ForwardRef as ReactComponent };